export enum InputSizes {
  l = 'l',
  m = 'm',
  s = 's',
}
